import dayjs from 'dayjs';

export const WORKER_ACTION = {
  PROCESS_DATA: 'PROCESS DATA',
  FILTER_AND_SORT: 'FILTER AND SORT',
};

export const EVENT_TYPE = {
  AUTOMATED_UPDATE: 'AgentAutomatedUpdate',
  COMMUNICATIONS: 'CommunicationsRecordGraphql',
  DIGITAL_WALLET_EVENT: 'AccountDigitalWalletEvent',
  MEMO: 'GraphQLAccountMemo',
};

export const TYPE_FILTER = {
  DIGITAL_WALLET: 'digital-wallet',
  EMAIL: 'email',
  FRAUD_ALERT: 'fraud-alert',
};

export const ALERT_TYPE = {
  DIGITAL_WALLET: 'DIGITAL_WALLET',
  FRAUD: 'FRAUD',
};

export const formatAutomatedUpdateEvent = (event) => {
  let body = event.message;

  // Older address update notes have the addresses stored as JSON strings
  // This just removes the JSON markup and displays the addresses as plaine text
  if (body?.toLowerCase().indexOf('new address') > -1) {
    const matches = body.match(/({[^{}]*})/g);

    if (matches) {
      let currentAddress = JSON.parse(matches[0]);
      let previousAddress = JSON.parse(matches[1]);

      body = body.replace(
        /{[^{}]*}/,
        `${currentAddress.street1}${currentAddress.street2 || ''},\n${
          currentAddress.city
        }, ${currentAddress.state} ${currentAddress.zip}`,
      );

      body = body.replace(
        /{[^{}]*}/,
        `${previousAddress.street1}${previousAddress.street2 || ''},\n${
          previousAddress.city
        }, ${previousAddress.state} ${previousAddress.zip}`,
      );
    }
  }

  return {
    ...event,
    localizedDate: dayjs.unix(parseFloat(event.createdTz)),
    body,
  };
};

export const formatCommunicationsEvent = (event) => {
  return {
    ...event,
    localizedDate: dayjs(event.sentDate),
    body: `${event.communicationType}: ${event.actionName} - ${event.title}`,
  };
};

export const formatMemoEvent = (event) => {
  return {
    ...event,
    localizedDate: dayjs(`${event.date} ${event.time}`),
    body: `${event.type} - ${event.alertType} - Sent via ${event.notificationChannel} - Account ID: ${event.accountId}`,
  };
};

export const formatProvisioningHistoryEvent = (event) => {
  const body = `
    Account Provisioning<br/>
    Account ID: ${event.accountId}<br/>
    Token Number: ${event.tokenNumber}<br/>
    Token Requester ID: ${event.tokenRequesterId}<br/>
    Reason: ${event.reason || '-'}
  `;

  return {
    ...event,
    localizedDate: dayjs(`${event.date} ${event.time}`),
    body,
  };
};
